var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-nav c-nav--floating-footer-sticky"},[_c('ButtonDefinitive',{attrs:{"label":"Descargar envíos"},on:{"click":_vm.next}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }